export default __webpack_public_path__ + "static/media/hear-white.ad005ee5.svg";